module.exports = __webpack_public_path__ + "static/media/futureplanet.208d57a8.png";